import { api } from "./api";
import { endpoints } from "./endpoints";

export interface GiftCheckoutData {
  teamSchema: string;
  user: {
    userId?: number;
    accountId: number;
    accountGroupIds?: string[];
    firstName?: string;
    lastName?: string;
    email?: string;
    phoneNumber?: string;
  };
  giftCardId: number;
  cardDetail?: {
    cardNumber: string;
    cardCvc: string;
    cardExpiry: string;
    address: string;
    zipCode: number;
    firstName: string;
    lastName: string;
    saveCard: boolean;
  };
  savedCard?: {
    ccSeqId: number;
    ccType: string;
  };
  sendNow: boolean;
  recipientDetails?: {
    email: string;
    message?: string;
  };
}

export type GiftCardRedeemData = {
  teamSchema: string;
  user: {
    accountId: number;
    email: string;
  };
  couponCode: string;
};

export type GiftCardSalesByAccountId = {
  teamSchema: string;
  accountId: number;
};

export const purchaseGiftCardApi = async (payload: GiftCheckoutData) => {
  return await api.post(endpoints.purchaseGiftCard, payload, {
    timeout: 30000,
  });
};

export const getGiftCardsApi = async (payload: { teamSchema: string }) => {
  return await api.post(endpoints.getGiftCards, payload);
};

export const redeemGiftCardApi = async (payload: GiftCardRedeemData) => {
  return await api.post(endpoints.redeemGiftCard, payload);
};

export const getGiftCardSalesByAccountIdApi = async (
  payload: GiftCardSalesByAccountId
) => await api.post(endpoints.getGiftCardSalesByAccountId, payload);
